'use strict';

angular.module('atex.dam').controller('DamSitesPickerModalController', ['$scope','$translate',
  function($scope, $translate) {
    $scope.panelTitle = $translate.getTranslationTable().__ASSOCIATED_SITES_TITLE__;
    $scope.loaded = false;
    $scope.showSpinner = true;
    $scope.sites = atex.Content();

    $scope.excludedSiteRegex = atex.onecms.ObjectUtils.getByPath($scope.field, "value/config/excludedSiteRegex") || "";
    $scope.selectDefaultSite  = atex.onecms.ObjectUtils.getByPath($scope.field, "value/configselectDefaultSite");
    $scope.selectExcludedSites = atex.onecms.ObjectUtils.getByPath($scope.field, "value/config/selectExcludedSites");

    if($scope.queryModel.set[$scope.fieldName] !== undefined){
      $scope.queryModel.set[$scope.fieldName].forEach(function(value){
        var site = 'contentid/' + value;
        $scope.data.push(site);
      });
    }

    $scope.sites.data.aspects = {
      "contentData": {
        "data": {
          "_type": "atex.onecms.article",
          "locations": []
        }
      },
      "p.InsertionInfo": {
        "data": {
          "_type": "p.InsertionInfo",
          "associatedSites": $scope.data
        }
      },
      "atex.Metadata": {
        "data":{
          "_type": "atex.Metadata",
          "taxonomyIds": []
        }
      }
    };

    $scope.template = {
      "id": "dam.site.picker",
      "dataBindings": [
        {
          "name": "associatedSites",
          "widget": "pAssociatedSites",

          "config": {
            "excludedSiteRegex" : $scope.excludedSiteRegex,
            "selectDefaultSite" : $scope.selectDefaultSite,
            "selectExcludedSites": $scope.selectExcludedSites
          },

          "domainObjects": {
            "associatedSites": "p.InsertionInfo/associatedSites",
            "taxonomyIds": "atex.Metadata/taxonomyIds"
          }
        }
      ]
    };

    $scope.loaded = true;

    $scope.hideSpinner = function () {
      $scope.showSpinner = false;
    };

    $scope.changeEndCallback = function (data) {
      $scope.data = data.aspects['p.InsertionInfo'].data.associatedSites;
      $scope.dirty = true;
      $scope.$digest();
      return;
    };

    $scope.doOK = function () {
      $scope.queryModel.set[$scope.fieldName]=[];
      $scope.data.forEach(function(point){
        if( point !== undefined ){
          var value = point.slice(10);
          $scope.queryModel.set[$scope.fieldName].push(value);
        }
      });
      $scope.$parent.doSave();
    };

  }]);